import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { REGISTER_URL, getHeadline } from '../../pricing';

const { FiCalendar, FiUsers, FiMapPin } = FiIcons;

const Hero = () => {
  return (
    <section className="relative min-h-[78vh] py-24 flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752687521493-blob)'
        }}
      />

      <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-red-900/40" />

      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="space-y-5"
        >
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
            <span className="block text-amber-300">พิธีเชื่อมพลังเทพมังกร</span>
            <span className="block text-2xl sm:text-3xl lg:text-4xl mt-2">
              ไหว้เจ้าพ่อเขาใหญ่ เกาะสีชัง
            </span>
            <span className="block text-lg sm:text-xl lg:text-2xl mt-4 text-gray-200">
              ณ ศาลเจ้าพ่อเขาใหญ่ เกาะสีชัง อ.ศรีราชา จ.ชลบุรี
            </span>
          </h1>

          <div className="flex flex-wrap justify-center gap-6 text-white">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3, duration: 0.6 }}
              className="flex items-center space-x-2"
            >
              <SafeIcon icon={FiCalendar} className="w-5 h-5 text-amber-300" />
              <span className="text-lg">วันพฤหัสที่ 19 พ.ย. 2569</span>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.5, duration: 0.6 }}
              className="flex items-center space-x-2"
            >
              <SafeIcon icon={FiUsers} className="w-5 h-5 text-amber-300" />
              <span className="text-lg">จำกัด 36 ท่าน</span>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.7, duration: 0.5 }}
            className="bg-green-600/90 text-white font-bold py-2 px-6 rounded-full inline-block"
          >
            {getHeadline() ? `เปิดลงทะเบียนแล้ว — ${getHeadline()}` : 'ปิดรับลงทะเบียนแล้ว'}
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.9, duration: 0.6 }}
            className="pt-4"
          >
            <a
              href={REGISTER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-10 py-5 bg-gradient-to-r from-green-600 to-green-700 text-white text-xl font-semibold rounded-full hover:from-green-700 hover:to-green-800 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <SafeIcon icon={FiMapPin} className="w-6 h-6 mr-3" />
              ลงทะเบียนเข้าร่วมทริปนี้
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;